// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__2__BI","content":"Layout_content__D16mi"};